import React from 'react'
import PropTypes from 'prop-types'

export interface ReviewRepliesCountProps {
  count: number
}

const ReviewRepliesCount = ({ count }: ReviewRepliesCountProps): React.ReactElement => {
  const renderCount = count < 0 ? 0 : count
  const renderCountText = renderCount === 1 ? 'REPLY' : 'REPLIES'

  return (
    <div className='review-replies-count-container'>
      <div
        className='review-replies-count'
        data-tooltip
        data-position='bottom'
        data-alignment='left'
        title='Only pro suppliers can reply to reviews shared with them'
      >
        {renderCount} {renderCountText} <i className='far fa-question-circle' />
      </div>
    </div>
  )
}

ReviewRepliesCount.propTypes = {
  count: PropTypes.number.isRequired
}

export default ReviewRepliesCount
